'use client'

import { useLayoutEffect, useRef } from 'react'

/** 비동기 콜백에서는 마지막으로 반영된 렌더의 값만 읽는다. */
export function useLatest<T>(value: T) {
  const latest = useRef(value)
  useLayoutEffect(() => {
    latest.current = value
  }, [value])
  return latest
}
